import * as API from '@/services/API';

export default {
  get(id) {
    return API.apiClient.get(`/organisations/${id}`);
  },
  list(options) {
    const query = API.apiHelper.getQueryStringFromObject(options);
    return API.apiClient.get(`/organisations/${query}`);
  },
  paginate(link) {
    return API.apiClient.get(link);
  },
  search(options) {
    const query = API.apiHelper.getQueryStringFromObject(options);
    return API.apiClient.get(`/organisations/search${query}`);
  },
  async save(id, data) {
    if (id == 0) {
      return API.apiClient.post(`/organisations`, data);
    } else {
      return API.apiClient.put(`/organisations/${id}`, data);
    }
  },
  async organisationDuplicates(organisation_id, title) {
    return API.apiClient.get(`organisations/organisation-duplicates?title=${title}&organisation_id=${organisation_id}`);
  },
  async delete(id) {
    return API.apiClient.delete(`/organisations/${id}`);
  }
};
